import ApiClient from './alms-api';
import { Common } from '../core/common';
import { Log } from 'ng2-logger';
import { UserType } from '../models/enums/userType';
import { ActivityTypeEnums } from '../models/enums/ActivityType';
import { enrollmentStatus } from '../models/enums/enrollmentStatus';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';


const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;
let _common: Common;
const _logger = Log.create('Report Service');
const T = Translator.create();

export class ReportService {
    constructor() {
        _apiClient = new ApiClient();
        _common = new Common();
    }

    public async RequestActiveUsers(params: {
        startDate?: Date;
        endDate?: Date;
        userType?: UserType;
        spinnerId?: string;
        spinnerType?: 'get' | 'set';
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/activeusers', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestTotalUsers(params: {
        startDate?: Date;
        endDate?: Date;
        userType?: UserType;
        spinnerId?: string;
        spinnerType?: 'get' | 'set';
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/weeklyactiveusers', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestVirtualClassStats(params: {
        startDate?: Date;
        endDate?: Date;
        userType?: UserType;
        spinnerId?: string;
        spinnerType?: 'get' | 'set';
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/virtualclassduration', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestActiveStudents(params: {
        take: number;
        skip: number;
        userType?: UserType;
        spinnerId?: string;
        spinnerType?: 'get' | 'set';
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/activestudents', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestFrequentlyVisitedCourses(params: {
        take: number;
        skip: number;
        spinnerId?: string;
        spinnerType?: 'get' | 'set';
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/mostvisitedcourses', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
    public async RequestEnrollmentData(params: {
        selectedCourses: string[];
        selectedClasses: string[];
        selectedUsers: string[];
        selectedActivities: string[];
        selectedActivityTypes: ActivityTypeEnums[];
        selectedStatuses: enrollmentStatus[];
        beginDate?: string | Date;
        endDate?: string | Date;
        rowNames?: string[];
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/studentenrollment', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
    public async RequestReportTemplate() {
        return _apiClient
            .RequestAsync('POST', 'api/report/reportTemplate', token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
    public async RequestReportChoises(guid : any) {
        return _apiClient
            .RequestAsync('POST', 'api/report/reportOption', guid,token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
    public async RequestAddReportTemplate(param: { cols: any; rows: any; name:any; }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/addReportTemplate', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification('success', T.t('r_report_template_add_succes_message'), 'topRight');
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_report_template_add_error_message'), 'topRight');
                return false;
            });
    }
    public async RequestUpdateReportTemplate(param: { cols: any; rows: any; name: any; templateGuid: any }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/updateReportTemplate', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification('success', T.t('r_report_template_add_succes_message'), 'topRight');
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_report_template_add_error_message'), 'topRight');
                return false;
            });
    }
    public async RequestDeleteReportTemplate(templateGuid: any) {
        return _apiClient
            .RequestAsync('POST', 'api/report/deleteReportTemplate', templateGuid, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification('success', T.t('r_report_template_delete_succes_message'), 'topRight');
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_report_template_delete_error_message'), 'topRight');
                return false;
            });
    }

    public async GetRedirectToAlmsActivityAndExamReportUrl(urlReturnType: string | undefined, activityId: string | undefined, classId?: string | undefined) {
        const parsedUrl = new URL(window.location.href);

        return _apiClient.RequestAsync('POST', 'api/account/ConnectWebToAlms', {
            host: parsedUrl.hostname,
            port: parsedUrl.port,
            scheme: parsedUrl.protocol,
            isReturnUrl: true,
            returnType: urlReturnType,
            courseId: '',
            classId: classId? classId : '',
            activityId: activityId ? activityId : '',
            enrollmentId: ''
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async GetMetabaseIdAsync(params: any) {
        const requestUrl = `api/report/metabase`;
        return _apiClient.RequestAsync('GET', requestUrl, params, '', false).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async GetMetabaseLinkAsync(metabaseId: any) {
        return _apiClient.RequestAsync('GET', `api/report//metabase-detail?metabaseId=${metabaseId}`, null).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
}
